import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const companySubscriptionsSlice = createSlice({
    name: 'ui/company-subscriptions',
    initialState: { ...initialState, populates: ['company', 'subscription', 'users'] },
    reducers: listReducers
})

export const companySubscriptionsActions = companySubscriptionsSlice.actions
export default companySubscriptionsSlice.reducer
